<template>

    <section class="hero page-title-container">

        <div class="hero-head">
            <div class="container">
                <slot name="titleHead"></slot>
            </div>
        </div>

        <div class="hero-body">
            <div class="container">
                <slot name="titleBody"></slot>
            </div>
        </div>

        <div class="hero-foot">
            <div class="container">
                <slot name="titleFooter"></slot>
            </div>
        </div>

    </section>
</template>

<script>
export default {
    name: 'titlePage'
  }

</script>
